import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randCreditCard } from "@ngneat/falso";

type Options = Exclude<Parameters<typeof randCreditCard>[0], undefined>;
type Brand = Exclude<Options["brand"], undefined> | "";

const brands: Record<Brand, string> = {
  "": "",
  "American Express": "American Express",
  UnionPay: "UnionPay",
  "Diners Club": "Diners Club",
  "Discover Card": "Discover Card",
  RuPay: "RuPay",
  JCB: "JCB",
  Maestro: "Maestro",
  Dankort: "Dankort",
  Mastercard: "Mastercard",
  Visa: "Visa",
  "Visa Electron": "Visa Electron",
  UATP: "UATP",
};

export const randCreditCardNodeDef = createNodeDef({
  type: "randCreditCard",
  displayName: "Credit Card",
  defaultName: "creditCard",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "brand",
      label: "Brand",
      options: brands,
    },
    {
      type: DataFieldType.TEXT,
      key: "fullName",
      label: "Full name",
    },
  ],
  initialData: (): { brand: Brand; fullName: string } => ({
    brand: "",
    fullName: "",
  }),
  generate: ({ node }) => {
    return randCreditCard({
      brand: node.data.brand || undefined,
      fullName: node.data.fullName || undefined,
    });
  },
});
